import { render, staticRenderFns } from "./ReferralsView.vue?vue&type=template&id=71143460&scoped=true"
import script from "./ReferralsView.vue?vue&type=script&lang=js"
export * from "./ReferralsView.vue?vue&type=script&lang=js"
import style0 from "./ReferralsView.vue?vue&type=style&index=0&id=71143460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71143460",
  null
  
)

export default component.exports